// `next()` returns a number for numeric revisions ("1" becomes 2). Calling
// `.match` on that number throws `i.match is not a function` from Revise
// Miscellaneous. Anything that is not a letter or number falls back to A.

export function miscellaneousRevisionLabel(nextRevision) {
    const text = typeof nextRevision === "string" || typeof nextRevision === "number"
        ? String(nextRevision)
        : "";
    return /^[0-9a-zA-Z]+$/.test(text) ? text : "A";
}
